import { render, staticRenderFns } from "./InspectionSecondStep.vue?vue&type=template&id=18d5864f&"
import script from "./InspectionSecondStep.vue?vue&type=script&lang=ts&"
export * from "./InspectionSecondStep.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionSecondStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports